module.exports = __webpack_public_path__ + "static/ic-menu-immunity-passport-pressed-42efe0f23e7b81261e37d7e5367644d1.svg";